import api from "./api";

class TipoEffetto {
    tipiEffetto(config?: any) {
        return api.get(`/tipi_effetto/`, config)
    }

    tipoEffetto(te_id: number | string) {
        return api.put(`/piano_di_fatturazione/${te_id}/`)
    }

    retrieve = this.tipoEffetto
    list = this.tipiEffetto

}

const tipoEffettoManager = new TipoEffetto()

export default tipoEffettoManager

